import React, { Component } from 'react';
import { AuthenticatedUser, Language } from '~/AccessToken';
import { EnglishHelp } from '~/Help/EnglishHelp';

import styles from './styles.less';

interface Props {
	scrollOnExport: boolean;
	user: AuthenticatedUser | undefined;
}

export default class HelpPage extends Component<Props> {
	static defaultProps = {
		scrollOnExport: false,
	};

	render() {
		const { user, scrollOnExport } = this.props;

		if (user == null) {
			return null;
		}

		switch (user.language) {
			case Language.cs:
			case Language.sk:
				return <iframe className={styles.iframe} src='https://help.cogvio.com/price-monitor/' />;
			default:
				return <EnglishHelp scrollOnExport={scrollOnExport} />;
		}
	}
}
